import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CalsoftMockApiService } from './mock-api.service';
import { CalsoftMockApiInterceptor } from './mock-api.interceptor';

@NgModule({
    providers: [
        CalsoftMockApiService,
        {
            provide : HTTP_INTERCEPTORS,
            useClass: CalsoftMockApiInterceptor,
            multi   : true
        }
    ]
})
export class CalsoftMockApiModule
{
    /**
     * forRoot method for setting user configuration
     *
     * @param mockDataServices
     */
    static forRoot(mockDataServices: any[]): ModuleWithProviders<CalsoftMockApiModule>
    {
        return {
            ngModule : CalsoftMockApiModule,
            providers: [
                {
                    provide   : APP_INITIALIZER,
                    deps      : mockDataServices,
                    useFactory: () => () => null,
                    multi     : true
                },
            ]
        };
    }
}
